// resources/js/admin/components/shared/pages/PagesList.tsx

import { Page } from "../../../types/features/Page";
import TableList, { SelectAction } from "../../ui/TableList";
import PageRow from "./PageRow";

interface PagesListProps {
    pages: Page[];
    onAction: (page: Page) => void;
    onSelectPages?: (selectedPages: Page[]) => void;
    selectable?: boolean;
    selectActions?: SelectAction[];
    loading?: boolean;
    emptyMessage?: string;
}

export default function PagesList({
    pages,
    onAction,
    onSelectPages,
    selectable = false,
    selectActions,
    loading = false,
    emptyMessage = "Aucune page trouvée",
}: PagesListProps) {

    const columns = [
        { header: "Page", className: "w-1/4" },
        { header: "Statut", className: "hidden md:table-cell w-1/6" },
        { header: "Version", className: "hidden lg:table-cell w-1/6" },
        { header: "Modifiée", className: "hidden xl:table-cell w-1/6" },
    ];

    if (loading) {
        return (
            <div className="flex justify-center items-center py-12">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
        );
    }

    return (
        <TableList
            items={pages}
            columns={columns}
            getId={(page) => page.id}
            onAction={onAction}
            onSelectItems={onSelectPages}
            selectable={selectable}
            emptyMessage={emptyMessage}
            actionColumn={true}
            selectActions={selectActions}
            renderRow={(page, isSelected, onSelect) => (
                <PageRow
                    key={page.id}
                    page={page}
                    onAction={onAction}
                    onSelect={onSelect}
                    isSelected={isSelected}
                    selectable={selectable}
                />
            )}
        />
    );
}